export const PACKAGE_CLASSNAME = 'header-package';
export const BODY_SIDEBAR_SHOWN_CLASS = 'menu-shown';
export const LOGO_BASE_CLASS = 'site-logo';
